import * as React from 'react';
import style from './BecomeMemberPanel.module.scss';
import { ArrowRightOutlined } from '@ant-design/icons';
import { ReactElement } from 'react';
import classNames from 'classnames';

interface BecomeMemberPanelProp {
    contentBox?: ReactElement;
    title?: string;
    desc?: string;
    onClick?: () => void;
    containerStyle?: string;
}

const BecomeMemberPanel: React.FC<BecomeMemberPanelProp> = ({
    contentBox,
    title,
    desc,
    onClick,
    containerStyle
}) => {
    const panelStyle = classNames(style.panel, {
        [containerStyle as string]: !!containerStyle
    });

    return (
        <div className={panelStyle}>
            {!!contentBox && (
                <div className={style.contentEl}>{contentBox}</div>
            )}
            {!!title && !!desc && (
                <div className={style.content}>
                    <span className={style.title}>{title}</span>
                    <span className={style.desc}>{desc}</span>
                </div>
            )}

            <button
                className={style.button}
                onClick={() => !!onClick && onClick()}>
                Meld deg inn i dag
                <ArrowRightOutlined />
            </button>
        </div>
    );
};

export default BecomeMemberPanel;
